import React, { useContext, useState, useEffect } from "react";
import { FiSearch } from "react-icons/fi";
import { Link } from "react-router-dom";
import Moment from "moment";

import { Container, Content } from "./styles";

import { ProcessProps } from "../../../types/ProcessTypes";

import SessionContext from "../../../contexts/sessionContext";
import QuestionContext from "../../../contexts/QuestionContext";

import api from "../../../services/api";

function Consulta() {
	const { user } = useContext(SessionContext);

	const [searchTerm, setSearchTerm] = useState("");

	// Ver comentarios do QuestionContext para entender
	const { setProcessId, reloadContext } = useContext(QuestionContext);

	const [process, setProcess] = useState<ProcessProps[]>();
	const [selectedProcess, setSelectedProcess] = useState<ProcessProps>();

	const slicedName = selectedProcess?.proponent_name.split(" ");

	const slicedFirstName = slicedName !== undefined ? slicedName[0] : null;

	const slicedLastName =
		slicedName !== undefined && slicedName.length <= 2
			? slicedName[1]
			: slicedName !== undefined && slicedName.length >= 3
			? slicedName[1] + " " + slicedName[2]
			: null;

	const handleAnalist = async (id: any) => {
		await api.patch(`/data/process&id=${id}/defineAnalist`, {
			user_id: user.id,
		});

		await api.patch(`/data/process&id=${id}/status`, {
			status: 2,
		});
	};

	console.log(selectedProcess);

	const ProcessComp = (process: ProcessProps) => {
		return (
			<tr
				className='process-container'
				key={process.id}
				onClick={() => {
					setSelectedProcess(process);
					setProcessId(process.id);
				}}>
				<td>{process.proponent_name}</td>
				<td>{process.cpf} </td>
				<td>{Moment(process.createdAt).format("DD/MM/YYYY")} </td>
				<td>{process.typist_one}</td>
				<td>{process.typist_two}</td>
				<td>
					<Link to={`/step-two`}>
						<button
							className='get-in'
							onClick={() => handleAnalist(process.id)}>
							ENTRAR
						</button>
					</Link>
				</td>
				<td>
					{process.status === 0
						? "Aguardando"
						: process.status === 1
						? "Pendente"
						: process.status === 2
						? "Em progresso"
						: process.status === 3
						? "Aprovado"
						: process.status === 4
						? "Reprovado"
						: process.status === 5
						? "Com divergência"
						: process.status === 6
						? "Aguardando análise"
						: null}
				</td>
			</tr>
		);
	};

	useEffect(() => {
		reloadContext();
	}, []);

	useEffect(() => {
		const process_data = async () => {
			try {
				const { data } = await api.get("/data/process");

				if (data.data) setProcess(data.data);
			} catch (error) {
				return error;
			}
		};

		process_data();
	}, []);

	useEffect(() => {
		const selected = () => {
			if (process !== undefined) {
				setSelectedProcess(process[0]);
			}
		};

		selected();
	}, []);

	return (
		<Container>
			<Content>
				<div className='header'>
					<p id='func'>Analista</p>
					<p id='name'>{user.name}</p>
				</div>
				<div className='process-wrapper'>
					<div className='consult-container'>
						<div className='process-header'>
							<p id='title'>CONSULTA</p>

							<div className='input-wrapper'>
								<FiSearch id='search-svg' />
								<input
									type='text'
									id='searchbar'
									placeholder='Procurar processo'
									onChange={(e) =>
										setSearchTerm(e.target.value)
									}
								/>
							</div>
							<hr />
						</div>

						<div className='table-wrapper'>
							<div className='table-content'>
								<table>
									<thead>
										<tr id='table-header'>
											<th>Nome do proponente</th>
											<th>CPF</th>
											<th>Data</th>
											<th>Digitador 1</th>
											<th>Digitador 2</th>
											<th>Analista</th>
											<th>Status</th>
										</tr>
									</thead>
									<tbody>
										{process ? (
											process
												.filter((item) => {
													if (
														item.status === 0 ||
														(user.id ===
															item.analist?.id &&
															item.status !== 1 &&
															item.status !== 3 &&
															item.status !== 4 &&
															item.status !== 6)
													) {
														return item;
													}
												})

												// filtro para saber se o precesso está com o status aguardando.
												// lista dos status no gerenciamento de processo.

												.filter((item) => {
													if (searchTerm === "") {
														return item;
													} else if (
														item.proponent_name
															.toLowerCase()
															.includes(
																searchTerm.toLowerCase(),
															)
													) {
														return item;
													} else if (
														item.cpf.includes(
															searchTerm,
														)
													) {
														return item;
													}
												})

												// filtro do searchbar, pesquisa por nome ou cpf.

												.map((process) => {
													return (
														<ProcessComp
															key={process.id}
															id={process.id}
															proponent_name={
																process.proponent_name
															}
															cpf={process.cpf}
															createdAt={
																process.createdAt
															}
															typist_one={
																process
																	.typist_one
																	?.name
															}
															typist_two={
																process
																	.typist_two
																	?.name
															}
															status={
																process.status
															}
															analist={
																process.analist
																	?.name
															}
														/>
													);
												})
										) : (
											<tr></tr>
										)}
									</tbody>
								</table>
							</div>
						</div>
					</div>

					<div className='process-details'>
						<div className='process-prop-name'>
							<p className='prop-name'>
								{selectedProcess !== undefined
									? slicedFirstName?.toLowerCase()
									: null}
								<br />
								{selectedProcess !== undefined
									? slicedLastName?.toLowerCase()
									: null}
							</p>
							<p className='prop-cpf'>
								{selectedProcess !== undefined
									? selectedProcess.cpf
									: null}
							</p>
						</div>

						{selectedProcess !== undefined ? (
							<div className='process-infos'>
								<div className='progress-wrapper'>
									<div className='progress-title'>
										<p>Status</p>
									</div>

									<div className='progress-status'>
										<p>
											{selectedProcess?.status === 0
												? "Aguardando"
												: selectedProcess?.status === 1
												? "Pendente"
												: selectedProcess?.status === 2
												? "Em progresso"
												: selectedProcess?.status === 3
												? "Aprovado"
												: selectedProcess?.status === 4
												? "Reprovado"
												: selectedProcess?.status === 5
												? "Com divergência"
												: selectedProcess?.status === 6
												? "Aguardando análise"
												: null}
										</p>
									</div>
								</div>

								<div className='process-info'>
									<p className='process-info-title'>DADOS</p>
									<table>
										<tr>
											<th>CPF</th>
											<td>{selectedProcess?.cpf}</td>
										</tr>
										<tr>
											<th>Data do processo</th>
											<td>
												{Moment(
													selectedProcess?.createdAt,
												).format("DD/MM/YYYY")}
											</td>
										</tr>

										<tr>
											<th>Digitador 1</th>
											<td>
												{selectedProcess?.typist_one}
											</td>
										</tr>

										<tr>
											<th>Digitador 2</th>
											<td>
												{selectedProcess?.typist_two}
											</td>
										</tr>

										<tr>
											<th>Analista</th>
											<td
												id={"get-in"}
												className={"analist-name"}>
												{selectedProcess?.analist}
											</td>
										</tr>

										<tr>
											<th>Status</th>
											<td>
												{selectedProcess?.status === 0
													? "Aguardando"
													: selectedProcess?.status ===
													  1
													? "Pendente"
													: selectedProcess?.status ===
													  2
													? "Em progresso"
													: selectedProcess?.status ===
													  3
													? "Aprovado"
													: selectedProcess?.status ===
													  4
													? "Reprovado"
													: selectedProcess?.status ===
													  5
													? "Com divergência"
													: selectedProcess?.status ===
													  6
													? "Aguardando análise"
													: null}
											</td>
										</tr>
									</table>
								</div>
							</div>
						) : (
							<div className='no-process-selected'>
								<p>Nenhum processo selecionado</p>
							</div>
						)}

						<div className='get-in-process'>
							{selectedProcess !== undefined &&
							selectedProcess.status === 5 ? (
								<Link
									to={`/processo-com-erro&id=${selectedProcess.id}`}>
									<button id='get-in-process'>
										CORRIGIR
									</button>
								</Link>
							) : (
								<></>
							)}
						</div>
					</div>
				</div>
			</Content>
		</Container>
	);
}

export default Consulta;
